import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CART_KEY = "tz_cart";
const CartContext = createContext(null);

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(CART_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveToStorage(items) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  } catch {
    /* quota exceeded — ignore */
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => loadFromStorage());

  useEffect(() => {
    saveToStorage(items);
  }, [items]);

  const addItem = useCallback((item) => {
    // item: { product_slug, product_name, configuration, unit_price_eur, preview_config }
    const line = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      qty: 1,
      ...item,
    };
    setItems((prev) => [...prev, line]);
  }, []);

  const removeItem = useCallback((id) => {
    setItems((prev) => prev.filter((it) => it.id !== id));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const total = items.reduce((s, it) => s + (Number(it.unit_price_eur) || 0) * (it.qty || 1), 0);
  const count = items.reduce((s, it) => s + (it.qty || 1), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
